/**
 * What the log-in page says when login() rejects. AuthContext throws an Error with the answer's
 * status (err.status) and body (err.data): 400 {message} ('Email or Username Not Registered',
 * 'Incorrect Password'), 400 {verified:false}, 429 {error}, and, after a right password, 403
 * {error, message} for an account that may not sign in (the portal's account.state.js).
 *
 * Returns { title, text?, verify?, admin? }: verify names a link to /verify-email, admin one to /admin.
 */
export function loginProblem(err) {
    const data = err?.data || err?.body || {};
    const code = typeof data.error === 'string' ? data.error : '';
    const message = data.message || data.error || err?.message || '';
    if (err?.name === 'TypeError') {
        return { title: 'We couldn’t reach enAble.', text: 'Check your connection and try again.' };
    }
    if (code === 'account_frozen') return { title: 'This account is paused. Contact your clinic.' };
    if (code === 'experience_ended') return { title: 'This experience account has ended.' };
    if (code === 'account_removed') return { title: 'This account was removed. Contact your clinic.' };
    if (code === 'admin_account') return { title: 'This is an admin account.', admin: 'Admin sign-in' };
    if (err?.status === 429 || /too many/i.test(message)) {
        return { title: 'Too many attempts.', text: 'Wait a few minutes, then try again.' };
    }
    if (data.verified === false || /not verified/i.test(message)) {
        return { title: 'Your email isn’t verified yet.', verify: 'Send a new link' };
    }
    if (/not registered|incorrect password/i.test(message)) {
        return { title: 'Email or password is incorrect.' };
    }
    return {
        title: 'We couldn’t log you in.',
        verify: 'Resend verification email',
    };
}
